<kendo-dialog
  *ngIf="isVisible()"
  [title]="'Configure SLA Targets'"
  (close)="onCancel.emit()"
  [minWidth]="350"
  [width]="400"
>
  <div class="d-flex flex-column gap-4">
    <div>
      <label class="form-label text-danger mb-2">Critical Vulnerabilities (9.0-10.0)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [ngModel]="slaValues().critical"
          (ngModelChange)="updateCritical($event)"
          min="1"
          max="90"
        />
        <span class="input-group-text">days</span>
      </div>
    </div>
    <div>
      <label class="form-label text-warning mb-2">High Vulnerabilities (7.0-8.9)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [ngModel]="slaValues().high"
          (ngModelChange)="updateHigh($event)"
          min="1"
          max="90"
        />
        <span class="input-group-text">days</span>
      </div>
    </div>
    <small class="text-muted">Set target SLA values between 1-90 days</small>
  </div>
  <kendo-dialog-actions>
    <button
      kendoButton
      (click)="onCancel.emit()"
    >
      Cancel
    </button>
    <button
      (click)="onSave.emit(slaValues())"
      [disabled]="
        slaValues().critical == null ||
        slaValues().high == null ||
        !slaValues().critical ||
        !slaValues().high ||
        (slaValues().critical ?? 0) < 1 ||
        (slaValues().critical ?? 0) > 90 ||
        (slaValues().high ?? 0) < 1 ||
        (slaValues().high ?? 0) > 90
      "
      [themeColor]="'primary'"
      kendoButton
    >
      Save Changes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
